import { VBase } from "./VBase";
import { ContentType } from "./_VSoftKeyboard.js";

const defaultOptions = {
  placeholder: "请输入内容",
  text: "",
  map: null,
  color: 0xffffff,
  opacity: 1.0,
  textSize: 0.03,
  textColor: 0x000000,
  textLimit: 0,
  width: 0.2,
  height: 0.1,
  radius: 0.01,
  outlineWidth: 0.001,
  font: "normal",
  align: "center",
  contentType: "Standard",
  stateChangeImage: null,
  stateChangeColor: null,
  disabledColor: 0xc8c8c8,
  enabledCb: null,
};

/*
  使用案例

      // 搜索框
      {
        const container2 = this.uiLib.createContainer({
          opacity: 0.5,
          width: 0.6,
          height: 0.1,
          color: 0xffffff,
          radius: 0.0,
          dragable: false,
        });

        const searchIconPath = "/assets/vrUI/EditPanel_Material/searchIcon.png";
        const searchIcon = await this.manager.loadManager.loadTexture(
          searchIconPath
        );
        const searchBtn = this.uiLib.createBtn({
          map: searchIcon,
          text: "",
          color: "#A8B4DB",
          width: 0.07,
          height: 0.07,
          radius: 0,
          stateChangeColor: {
            normal: 0xa8b4db,
            hover: 0xffffff,
            click: 0x4f5670,
          },
        });
        searchBtn.addClickEvent((btn) => {
          console.log("点击搜索按钮，开始搜索内容：" + this.inputfiled.text);
        });
        searchBtn.position.x = -0.22;
        searchBtn.position.z = 0.001;
        container2.add(searchBtn);

        this.inputfiled = this.uiLib.createInputField({
          textColor: "#A8B4DB",
          textSize: 0.045,
          width: 0.45,
          height: 0.1,
          radius: 0.0,
          opacity: 0.1,
          align: "left",
          contentType: "Standard",
        });
        this.inputfiled.position.x = 0.06;
        this.inputfiled.position.z = 0.001;
        container2.add(this.inputfiled);

        this.uiLib.addUIToScene(container2);
      }
      // 实数输入框
      {
        const posInputFiled = this.uiLib.createInputField({
          width: 0.25,
          height: 0.1,
          radius: 0.02,
          color: 0x4f5670,
          text: "12.34",
          textColor: 0xa8b4db,
          opacity: 0.5,
          textSize: 0.04,
          font: "normal",
          align: "left",
          contentType: "DecimalNumber",
          stateChangeColor: {
            normal: 0xa8b4db,
            hover: 0xffffff,
          },
        });
        posInputFiled.addOnValueChangeEvent((text, obj) => {
          console.log("修改数值" + text);
        });
        posInputFiled.position.y = 0.2;
        this.uiLib.addUIToScene(posInputFiled);
      }


*/
export class VInputField extends VBase {
  /**
   * options:
   * {
   *      priority: 优先级，默认为0，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99999
   *      placeholder: 占位符文字，默认为"请输入内容",当没有文字内容text时显示此文字
   *      text: 按钮文字内容，默认为"按钮"
   *      map: 按钮背景贴图，不是贴图地址，默认为null
   *      color: 按钮颜色。默认为 0xffffff
   *      opacity: 1,按钮背景透明度，默认为1
   *      textSize: 文字大小，默认为 0.03
   *      textLimit: 文字显示数量限制，默认为 0,0表示不限制
   *      textColor: 文字颜色，默认为 0x000000
   *      width: 按钮宽度，默认为 0.2
   *      height: 按钮高度，默认为 0.1
   *      radius: 圆角半径，设为0则是矩形，默认为0.01
   *      font: 字体正常或粗体，"normal"-正常  "bold"-粗体 ，默认为"normal"
   *      outlineWidth: 文字描边宽度，默认为 0.001
   *      contentType: 内容类型，"Standard"-标准 "IntegerNumber"-整数，包括负整数，"DecimalNumber"-实数. 默认为"Standard"
   *      stateChangeImage: 按钮状态改变时的贴图对象，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   *      stateChangeColor: 按钮状态改变时的颜色对象，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   *      disabledColor: ui对象禁用颜色，默认为 0xC8C8C8
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      priority: options.priority !== undefined ? options.priority : 0,
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99999,
      text: options.text !== undefined ? options.text : defaultOptions.text,

      map: options.map ? options.map : defaultOptions.map,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      textSize: options.textSize ? options.textSize : defaultOptions.textSize,
      textLimit:
        options.textLimit !== undefined
          ? options.textLimit
          : defaultOptions.textLimit,
      align: options.align ? options.align : defaultOptions.align,
      textColor:
        options.textColor !== undefined
          ? options.textColor
          : defaultOptions.textColor,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
      outlineWidth:
        options.outlineWidth !== undefined
          ? options.outlineWidth
          : defaultOptions.outlineWidth,
      font: options.font ? options.font : defaultOptions.font,
      placeholder:
        options.placeholder !== undefined
          ? options.placeholder
          : defaultOptions.placeholder,
      contentType:
        options.contentType !== undefined
          ? options.contentType
          : defaultOptions.contentType,

      stateChangeImage: options.stateChangeImage
        ? options.stateChangeImage
        : null,
      stateChangeColor: options.stateChangeColor
        ? options.stateChangeColor
        : null,
      disabledColor:
        options.disabledColor !== undefined
          ? options.disabledColor
          : defaultOptions.disabledColor,
    };

    super(tempOptions, vuiLib);
    this._vType = "VInputField";

    this._otherProps = {
      placeholder: tempOptions.placeholder,
      contentType: tempOptions.contentType,
      onValueChange: [],
    };

    if (
      this._otherProps.contentType !== ContentType.Standard &&
      this._otherProps.contentType !== ContentType.IntegerNumber &&
      this._otherProps.contentType !== ContentType.DecimalNumber
    ) {
      this._otherProps.contentType = ContentType.Standard;
    }
    if (!tempOptions.text) tempOptions.text = "";
    if (
      this._otherProps.contentType === ContentType.IntegerNumber ||
      this._otherProps.contentType === ContentType.DecimalNumber
    ) {
      tempOptions.text = this._extractAndConvertToNumber(tempOptions.text);

      if (
        this._otherProps.contentType === ContentType.IntegerNumber &&
        tempOptions.text.indexOf(".") > -1
      ) {
        tempOptions.text = tempOptions.text.substring(
          0,
          tempOptions.text.indexOf(".")
        );
      }
    }

    this.text = tempOptions.text;

    this.name = "VInputField";

    this._createTextObj();
  }

  /**
   * 如果字符串中包含多个数字部分，可以提取第一个有效的数字部分。
   * @param {*} str
   * @returns
   */
  _extractAndConvertToNumber(str) {
    str += ""; // 避免传入的是数字
    // 使用正则表达式提取第一个有效的数字部分
    const match = str.match(/-?\d+(\.\d+)?/);

    // 如果找到匹配的部分，转换为数字；否则返回默认值（如 0）
    return match ? parseFloat(match[0]) + "" : ""; // 转成字符串
  }

  /**
   * 在外部修改输入框的内容
   * @param {*} text
   * @returns
   */
  changeValue(text) {
    if (this.text === text) return;
    this.text = text;
    this._createTextObj();
  }

  _createTextObj() {
    let str = this.text.length > 0 ? this.text : this._otherProps.placeholder;
    if (!str) str = "";

    if (this.lastContent && this.lastContent === str) return;

    this.lastContent = str;

    if (
      this._textProps.textLimit > 0 &&
      this._textProps.textLimit < str.length
    ) {
      str = str.substring(0, this._textProps.textLimit - 1) + "...";
    }

    if (this.textObj) {
      if (this.vuilib) this.vuilib.removeUI(this.textObj);
      else this.textObj.clear();
      this.textObj = null;
    }

    // 文字
    this.textObj = this.vuilib.createText({
      text: str,
      textSize: this._textProps.textSize,
      textColor: this._textProps.textColor,
      font: this._textProps.font,
      outlineWidth: this._textProps.outlineWidth,
      align: this._textProps.align,
    });
    this.textObj.position.z = 0.001;
    this.textObj.renderOrder = this._baseProps.renderOrder;
    if (this._textProps.align === "left") {
      this.textObj.position.x =
        -this._baseProps.width / 2 + this._textProps.textSize / 2;
    } else if (this._textProps.align === "right") {
      this.textObj.position.x =
        this._baseProps.width / 2 - this._textProps.textSize / 2;
    }
    this.add(this.textObj);
  }

  onSelectEnd() {
    if (!this._otherProps || !this._baseProps.enabled) return;

    super.onSelectEnd();

    // 打开软键盘
    this.vuilib.showKeyboard(
      this.text,
      this._otherProps.contentType,
      (text) => {
        this.text = text;

        this._createTextObj();

        for (var i = 0; i < this._otherProps.onValueChange.length; i++) {
          this._otherProps.onValueChange[i](this.text, this);
        }
      }
    );
  }

  /**
   * 增加一个回调函数，当输入框输入完成后调用，参数为输入的文字和输入框对象
   * @param {*} fun
   * @returns
   */
  addOnValueChangeEvent(fun) {
    if (!fun) return;
    this._otherProps.onValueChange.push(fun);
  }

  /**
   * 移除一个 当输入框输入完成后调用 的回调函数，参数为输入的文字和输入框对象
   * @param {*} fun
   * @returns
   */
  removeOnValueChangeEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onValueChange.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onValueChange.splice(index, 1);
    }
  }

  /**
   * 移除所有 当value改变过程中调用 的回调函数
   */
  removeAllOnValueChangeEvent() {
    this._otherProps.onValueChange = [];
  }
}
